import { render, staticRenderFns } from "./PrimiumMarketBannerComponent.vue?vue&type=template&id=0c9e49fc&scoped=true"
import script from "./PrimiumMarketBannerComponent.vue?vue&type=script&lang=js"
export * from "./PrimiumMarketBannerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e49fc",
  null
  
)

export default component.exports